import React, {Component} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import InputField from '../new-ui/input_field';

class Receipt extends Component {
	constructor(props) {
		super(props);
		this.state = {
			shouldAnimate: false,
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.isOnboarding !== prevProps.isOnboarding && !this.state.shouldAnimate) {
			this.setState({shouldAnimate: true});
		}
	}
	discountCodeChange(e) {
		this.props.setDiscountCode(e);
	}

	selectBilling(val) {
		if (val === 'month') {
			this.props.setPaymentType('card');
		}
		this.props.setBilling(val);
	}

	handleOnboardingAnimationEnd() {
		this.setState({shouldAnimate: false});
	}

	getTotalWithVat() {
		return this.totalWithVat;
	}

	render() {
		const {formatMessage, formatNumber, formatDate} = this.props.intl;
		const {virtualSeats, selectedPlan, seats, isOnboarding, currencySymbol, virtualUser, selectedTier} = this.props;

		const virtualSeatPrice = virtualUser ? virtualUser.price / 100 : 0;
		const planPrice = selectedPlan.price / 100;
		const unitPrice = selectedPlan.periodUnit === 'YEAR' ? planPrice / (12 * selectedPlan.period) : selectedPlan.periodUnit === 'MONTH' ? planPrice / selectedPlan.period : null;
		const totalSeatsMonthly = seats * unitPrice;
		const totalVirtualSeatsMonthly = virtualSeats * virtualSeatPrice;
		let onboardingPrice = 0;
		if (selectedTier === 'PRO' || selectedTier === 'ENTERPRISE') {
			if (this.props.currency === 'DKK') {
				onboardingPrice = 15000;
			} else {
				onboardingPrice = 1999;
			}
		} else {
			if (this.props.currency === 'DKK') {
				onboardingPrice = 7500;
			} else {
				onboardingPrice = 999;
			}
		}

		const subTotal = totalSeatsMonthly + totalVirtualSeatsMonthly;
		let totalMonthly = subTotal;

		let total = this.props.billing === 'annual' ? subTotal * 12 : this.props.billing === 'quarter' ? subTotal * 3 : subTotal;
		let totalForPeriod =
			this.props.billing === 'annual' ? totalSeatsMonthly * 12 + totalVirtualSeatsMonthly * 12 : this.props.billing === 'quarter' ? totalSeatsMonthly * 3 + totalVirtualSeatsMonthly * 3 : totalSeatsMonthly + totalVirtualSeatsMonthly;
		let discount;
		if (this.props.appliedCoupon) {
			const coupon = this.props.appliedCoupon;
			if (coupon.duration.toLowerCase() === 'one_time') {
				if (coupon.percentOff !== null) {
					discount = 'Campaign code applied -' + coupon.percentOff + '%';
					total -= ((total * coupon.percentOff) / 100.0).toFixed(2);
				} else {
					discount = 'Campaign code applied -' + currencySymbol + coupon.amountOff / 100.0;
					total -= (coupon.amountOff / 100.0).toFixed(2);
				}
			} else if (coupon.duration.toLowerCase() === 'repeating') {
				if (coupon.percentOff !== null) {
					discount = 'Campaign code applied -' + coupon.percentOff + '% for ' + coupon.durationInMonths + ' Months';
					total -= ((total * coupon.percentOff) / 100.0).toFixed(2);
					totalForPeriod -= ((totalForPeriod * coupon.percentOff) / 100.0).toFixed(2);
					onboardingPrice -= ((onboardingPrice * coupon.percentOff) / 100.0).toFixed(2);
					totalMonthly -= ((totalMonthly * coupon.percentOff) / 100.0).toFixed(2);
				} else {
					discount = 'Campaign code applied -' + currencySymbol + coupon.amountOff / 100.0 + ' for ' + coupon.durationInMonths + ' Months';
					total -= (coupon.amountOff / 100.0).toFixed(2);
					totalForPeriod -= (coupon.amountOff / 100.0).toFixed(2);
					onboardingPrice -= (coupon.amountOff / 100.0).toFixed(2);
					totalMonthly -= (coupon.amountOff / 100.0).toFixed(2);
				}
			} else if (coupon.duration.toLowerCase() === 'forever' && coupon.percentOff !== null) {
				discount = 'Campaign code applied -' + coupon.percentOff + '% forever';
				total -= ((total * coupon.percentOff) / 100.0).toFixed(2);
				totalForPeriod -= ((totalForPeriod * coupon.percentOff) / 100.0).toFixed(2);
				onboardingPrice -= ((onboardingPrice * coupon.percentOff) / 100.0).toFixed(2);
				totalMonthly -= ((totalMonthly * coupon.percentOff) / 100.0).toFixed(2);
			}
		}
		if (isOnboarding) {
			total += onboardingPrice;
		}

		const billingSuffix = '/' + (this.props.billing === 'annual' ? formatMessage({id: 'common.year.short'}) : this.props.billing === 'quarter' ? formatMessage({id: 'common.quarter.short'}) : formatMessage({id: 'common.month.short'}));

		const vat = this.props.country === 'DK' ? 0.25 : 0;
		const totalWithVat = this.props.country === 'DK' ? total * (1 + vat) : total;
		this.totalWithVat = totalWithVat;
		const monthlyDiscount = this.props.appliedCoupon && (this.props.appliedCoupon.duration.toLowerCase() === 'forever' || this.props.appliedCoupon.duration.toLowerCase() === 'repeating');

		return (
			<div className="receipt">
				{this.props.hideMonthly ? null : (
					<div className={'trial-end-card top-section'}>
						<div className="plan-type-wrapper">
							<h1 className="plan-type">{formatMessage({id: 'receipt.your_monthly_cost'})}</h1>
						</div>
						<table className={'user-pricing-table'}>
							<thead>
								<tr>
									<th className={'receipt-table-header'}>{formatMessage({id: 'receipt.item'})}</th>
									<th className={'receipt-table-header'}>{formatMessage({id: 'common.quantity_short'})}</th>
									<th className={'receipt-table-header'}>{formatMessage({id: 'common.unit_price'})}</th>
									<th className={'receipt-table-header'}>{formatMessage({id: 'common.amount'})}</th>
								</tr>
							</thead>
							<tbody>
								<tr className={'receipt-row'}>
									<td className="pricing-label">{formatMessage({id: 'settings_subscription.users'})}</td>
									<td className={'pricing-calculation-users' + (!this.props.validateSeats() ? ' invalid' : '')}>{this.props.seats ? this.props.seats : this.props.users}</td>
									<td className={'unit-price'}>{currencySymbol + formatNumber(unitPrice, {format: 'always_two_decimal'})}</td>
									<td className={'pricing-total'}>{currencySymbol + formatNumber(totalSeatsMonthly, {format: 'always_two_decimal'})}</td>
								</tr>

								<tr className={'receipt-row last-row'}>
									<td className="pricing-label">{formatMessage({id: 'settings_subscription.virtual_users'})}</td>
									<td className={'pricing-calculation-users' + (!this.props.validateVirtualSeats() ? ' invalid' : '')}>{this.props.virtualSeats ? this.props.virtualSeats : this.props.virtualUsers}</td>
									<td className="pricing-calculation-price">{currencySymbol + formatNumber(virtualSeatPrice, {format: 'always_two_decimal'})}</td>
									<td className={'pricing-total'}>{currencySymbol + formatNumber(totalVirtualSeatsMonthly, {format: 'always_two_decimal'})}</td>
								</tr>
								{monthlyDiscount ? (
									<tr className={'discount-applied-monthly'}>
										<td colSpan="4" className="discount monthly">
											{discount}
										</td>
									</tr>
								) : null}
								<tr className={'sub-total' + (monthlyDiscount ? ' no-border-top' : '')}>
									<td className={'sub-total-header'}>{formatMessage({id: 'common.total'})}</td>
									<td />
									<td />
									<td className={'sub-total-text'}>{currencySymbol + formatNumber(totalMonthly, {format: 'always_two_decimal'})}</td>
								</tr>
							</tbody>
						</table>
					</div>
				)}
				{!this.props.hideTotal ? (
					<div className={'trial-end-card receipt-actuals'}>
						<div className="plan-type-wrapper">
							<div className="order-summary">{formatMessage({id: 'receipt.order_summary'})}</div>
						</div>
						<div className="period-total">
							<div className="selected-period bold-text">
								<p className="bold-text capitalize-first">
									{selectedTier === 'LITE' ? formatMessage({id: 'select_plan.lite_plan_name'}) : selectedTier === 'PRO' ? formatMessage({id: 'select_plan.pro_plan_name'}) : formatMessage({id: 'select_plan.enterprise_plan_name'})}
								</p>
								{' - '}
								<p className="bold-text capitalize-first">{this.props.billing}</p>
							</div>

							<div className={'selected-period-total'}>
								<span className={'non-bold'}>{currencySymbol + formatNumber(totalForPeriod, {format: 'rounded_two_decimal'})}</span>
								{billingSuffix}
							</div>
						</div>
						{this.props.isPaid ? (
							<div className={'user-breakdown'}>
								<div className={'user-count'}>
									{formatMessage({id: 'settings_subscription.users'})} ({this.props.seats + ' '}
									{formatMessage({id: 'common.seats'})})
								</div>
								<div className={'virtual user-count'}>
									{formatMessage({id: 'settings_subscription.virtual_users'})} ({this.props.virtualSeats + ' '}
									{formatMessage({id: 'common.seats'})})
								</div>
							</div>
						) : null}

						{isOnboarding ? (
							<div className={'onboarding-wrapper' + (this.state.shouldAnimate ? ' animated fadeIn' : '')} onAnimationEnd={this.handleOnboardingAnimationEnd.bind(this)}>
								<div className={'onboarding-first-line'}>
									<div className="onboarding-label bold-text">{formatMessage({id: 'settings_subscription.onboarding'})}</div>
									<div className="onboarding-price">{currencySymbol + formatNumber(onboardingPrice, {format: 'rounded_two_decimal'})}</div>
								</div>
							</div>
						) : null}
						{vat !== 0 && (
							<div className="period-vat">
								<div className="vat-label bold-text">VAT 25%</div>
								<div>{currencySymbol + formatNumber(totalWithVat - total, {format: 'rounded_two_decimal'})}</div>
							</div>
						)}
						{this.props.page === 'PAYMENT' ? (
							<div htmlFor="discount_code" className="discount-wrapper">
								{this.props.page === 'PAYMENT' && (
									<div className={'input-wrapper'}>
										<label htmlFor="discount_code">
											<InputField
												onEnter={this.props.applyCoupon}
												customClass={this.props.appliedCoupon ? 'green-border' : ''}
												hideLabel={true}
												onFocus={() => this.setState({discountInputFocused: true})}
												onBlur={() => this.setState({discountInputFocused: false})}
												placeholder={formatMessage({id: 'settings_subscription.discount-code'})}
												type="text"
												id="discount_code"
												size="70"
												onChange={this.discountCodeChange.bind(this)}
											/>
										</label>
										{this.props.appliedCoupon ? null : (
											<div className={'apply-code-text' + (this.state.discountInputFocused ? ' purple-text' : '')} onClick={this.props.applyCoupon}>
												<FormattedMessage id="settings_subscription.apply" />
											</div>
										)}
									</div>
								)}
								{this.props.discount_error && this.props.page === 'PAYMENT' ? (
									<div id="discount-errors" className={'coupon-error-text'}>
										{this.props.discount_error}
									</div>
								) : null}
								{this.props.appliedCoupon ? (
									<div className={'discount-applied-section'}>
										<div className={'discount-checkmark'} />
										<div className="discount">{discount}</div>
									</div>
								) : null}
							</div>
						) : null}
						{this.props.isPaid && this.props.appliedCoupon ? (
							<div htmlFor="discount_code" className="discount-wrapper">
								<div className={'discount-applied-section'}>
									<div className={'discount-checkmark'} />
									<div className="discount">{discount}</div>
								</div>
							</div>
						) : null}
						<div className="payment-total-wrapper">
							<div className="total-label">{this.props.isPaid && !this.props.dueDate ? formatMessage({id: 'common.total_paid'}) : formatMessage({id: 'common.total'})}</div>
							<div className="total-total">{currencySymbol + formatNumber(totalWithVat, {format: 'rounded_two_decimal'})}</div>
						</div>
						{this.props.dueDate ? <div className={'due-date-indicator'}>{formatMessage({id: 'common.due_on'}) + ' ' + formatDate(this.props.dueDate, {day: 'numeric', month: 'short', year: 'numeric'})}</div> : null}
					</div>
				) : null}
			</div>
		);
	}
}

export default injectIntl(Receipt, {forwardRef: true});
